export default __webpack_public_path__ + "static/header-contact-us-f294c5be2493d4ba05e2e9db1d1a9f6d.webp";